import { IPartMediaImage } from './media';

export interface IPartFieldValue {
  categoryId?: number | null;
  categoryName?: string | null;
  dataType?: string | null;
  displayPosition?: number | null;
  fieldId?: number | null;
  group?: string | null;
  name?: string | null;
  value?: string | string[] | null;
  valueNoUom?: string | string[] | null;
}

export interface IPartSpecifications {
  imagesData?: IPartMediaImage[];
  partFieldValues?: IPartFieldValue[];
}

export interface IPartSpecificationsRequestPayload {
  manufacturer: string;
  number: string;
}

export interface IPartFieldConfigUom {
  defaultDescriptor?: string | null;
  id?: string | number | null;
  name?: string | null;
}

// BE returns `byName` as an object when there are UOMs and as an empty array (`[]`) when
// there are none — PHP's empty associative-array serialization. Caller must guard with
// `Array.isArray()` before calling `Object.values()`.
export interface IPartFieldConfigAllowedUoms {
  byName?: Record<string, IPartFieldConfigUom> | unknown[] | null;
  ids?: Array<string | number> | null;
  names?: string[] | null;
}

export interface IPartFieldConfigDetails {
  allowMultiple?: boolean | null;
  allowedUoms?: IPartFieldConfigAllowedUoms | null;
  allowedValues?: Array<string | number> | null;
  example?: string | null;
  hidden?: string | number | null;
  isWhitelist?: number | null;
}

export interface IPartFieldConfig {
  config?: IPartFieldConfigDetails | null;
  dataType?: string | null;
  displayPosition?: number | null;
  fieldId?: number | null;
  group?: string | null;
  id?: number | null;
  name?: string | null;
  value?: string | string[] | null;
  valueNoUom?: string | string[] | null;
}

export interface IPartFieldConfigs {
  partFieldConfigColumns?: IPartFieldConfig[][];
}

export interface IPartFieldConfigsRequestPayload {
  manufacturer: string;
  number: string;
}

export interface IPartFieldSavePayload {
  partFieldId: number;
  values?: IPartFieldSaveValue[];
}

export interface IPartFieldSaveValue {
  uomId?: string | number;
  value: string;
}

export interface ISavePartParticularsPayload {
  fields: Record<string, IPartFieldSavePayload>;
  manufacturer: number;
  part: string;
}

export interface ISavePartParticularsResponse {
  error?: string;
  errors?: Array<{ field: string; message: string }>;
  success: boolean;
}

export enum PartMainDetailsField {
  STATUS = 'Active/Obsolete',
}

export enum PartSpecificationsGroupName {
  DIMENSIONS = 'Dimensions',
}

export enum PartActiveStatus {
  ACTIVE = 'Active',
  OBSOLETE = 'Obsolete',
}

export enum PartFieldDataType {
  BOOLEAN = 'boolean',
  DECIMAL = 'decimal',
  INTEGER = 'integer',
  STRING = 'string',
  TEXT = 'text',
}
